import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';

import { socket } from 'api';
import { user } from 'services/user';
import { Tooltip, Input, NumberInput, Range } from 'libs/ui';
import { ZoneInfo } from 'components/shared/zone/ZoneInfo';
import { setBoardsData } from '../../../store/actions/boards';
import { BoardWrapper, Comment, Label, Places, RangePlace, SizedBlueButton, Warn, TooltipPlace, Buttons } from './Board.styled';
import { RegularOptionsCheckbox } from './regular-options-checkbox';

export const Board = (props) => {
  const { t } = useTranslation();
  const { data } = props;
  const { zoneId, color } = data;
  const [comment, setComment] = useState('');

  const dispatch = useDispatch();
  const zone = useSelector((state) => state.boards.boards[zoneId], shallowEqual);
  const newVariant = !!zone.regular;

  // zone
  const min = 0;
  const max = zone ? zone.maximum : 0;
  const free = zone ? zone.free : 0;
  const regular = zone ? zone.regular : 0;
  const free_onetime = zone ? zone.free_onetime : 0;

  // current = occupied
  // free - физически свободных
  // total = maximum
  // one_time - всего мест для разовых клиентов

  // const cntOnetimeMax = free - regular;
  let currentFreeOnetime = free_onetime; //Math.min(free_onetime, cntOnetimeMax);
  if (currentFreeOnetime < 0) {
    currentFreeOnetime = 0;
  }

  const [newCount, setNewCount] = useState(free);
  const [newOnetime, setNewOnetime] = useState(currentFreeOnetime);
  const [onetimeMax, setOnetimeMax] = useState(max - regular);

  /**
   * update physical count
   * @param {*} val
   */
  const updateNewCount = (val) => {
    setNewCount(val);
  };

  // change onetime max if zone changes
  useEffect(() => {
    let newOnetimeMax = max - regular;
    if (newOnetimeMax < 0) {
      newOnetimeMax = 0;
    }
    setOnetimeMax(newOnetimeMax);

    let newOneTime1 = newOnetime; //Math.min(newOnetimeMax, currentFreeOnetime);
    if (newOneTime1 > newOnetimeMax) {
      newOneTime1 = newOnetimeMax;
    }
    if (newOneTime1 < min) {
      newOneTime1 = min;
    }
    setNewOnetime(newOneTime1);
  }, [zone]);

  /**
   * update onetime count
   * @param {*} val
   */
  const changeOneTime = (val) => {
    setNewOnetime(val);
  };

  const onSetZones = (msg) => {
    dispatch(setBoardsData([msg.zone]));
  };

  // const onGetZones = (msg) => {
  //   const zone = msg.zp;
  // };

  // change newOneTime value if max changes
  // useEffect(() => {
  //   if (newOnetime > currentFreeOnetime) {
  //     setNewOnetime(currentFreeOnetime);
  //   }
  // }, [newOnetime, currentFreeOnetime]);

  // get data
  useEffect(() => {
    // get zone status
    socket.call('get_zones_status');

    // change zone status
    // socket.on('get_zones_status', onGetZones);
    socket.on('set_zone_status', onSetZones);

    return () => {
      // socket.off('get_zones_status', onGetZones);
      socket.off('set_zone_status', onSetZones);
    };
  }, []);

  /**
   * update comment
   * @param {*} e
   */
  const updateComment = (e) => {
    setComment(e.target.value);
  };

  /**
   * save values
   */
  const accept = () => {
    socket.call(
      'set_zone_status',
      {
        user_id: user.getId(),
        zone_id: zoneId,
        // current: max - newCount, // null
        free: newCount,
        free_onetime: newOnetime,
        comment: comment,
      },
      () => {
        setComment('');
      },
    );
  };

  const rightRegular = user.haveRight('zones.set_regular_places');
  if (isNaN(onetimeMax)) {
    return null;
  }

  const showRange = onetimeMax > min && newOnetime >= min && newOnetime <= onetimeMax;

  return (
    <BoardWrapper>
      {newVariant && (
        <TooltipPlace>
          <Tooltip
            info={
              <Warn>
                {t('messages.Забронировано')} <b>{zone.regular}</b> {t('messages.постоянных мест из')} <b>{zone.maximum}</b>.{' '}
                {t('messages.Вы можете указать новое общее количество свободных мест')},{' '}
                {t('messages.в т ч забронированные места На табло отображается общее количество свободных мест')}
              </Warn>
            }
          />
        </TooltipPlace>
      )}

      <Places>
        <div className="left">
          <Label>{t('widgets.Общее')}</Label>
          <ZoneInfo zoneId={zoneId} color={color} className="in-window" />
        </div>
        <div className="right">
          <Label>{t('windows.Новое')}</Label>
          <NumberInput min={min} max={max} value={newCount} onChange={updateNewCount} className="number" />
        </div>
        <div className="right">
          <Label>{t('windows.Всего')}</Label>
          <Input value={max} disabled />
        </div>
      </Places>

      <Places>
        <div className="left">
          <Label>{t('widgets.Разовые')}</Label>
          <Input value={currentFreeOnetime ?? ''} disabled />
        </div>
        <div className="right">
          <Label>{t('widgets.Новое')}</Label>
          <NumberInput min={min} max={onetimeMax} value={newOnetime} onChange={changeOneTime} disabled={onetimeMax === 0} />
        </div>
        <div className="right">
          <Label>{t('windows.Всего')}</Label>
          <Input value={zone.onetime ?? ''} disabled />
        </div>
      </Places>

      <RangePlace>{showRange && <Range min={min} max={onetimeMax} value={newOnetime} onChange={changeOneTime} />}</RangePlace>

      <Comment>
        <Label>{t('windows.Комментарий')}</Label>
        <Input value={comment} onChange={updateComment} />
      </Comment>
      {rightRegular && (
        <Comment>
          <RegularOptionsCheckbox zoneId={zoneId} zone={zone} />
        </Comment>
      )}
      <Buttons>
        <SizedBlueButton onClick={accept}>{t('buttons.Применить')}</SizedBlueButton>
      </Buttons>
    </BoardWrapper>
  );
};
